import styled from 'styled-components';
import backgroundImage from 'assets/img/quizhive_bg_2019.png';
import { BLACK } from 'root/theme';

const AppContainer = styled.div`
  background: url(${backgroundImage});
  background-attachment: fixed;
  color: ${BLACK};
  background-size: cover;
  font-family: 'Montserrat', helvetica, arial, sans-serif;
  min-height: 100%;
`;

export {
  AppContainer,
};
